import React, { useEffect } from "react";
import styled from "styled-components";

const ToastWrapper = styled.div`
    position: fixed;
    top: 30px;
    left: 160px;
    background-color: #ffffff;
    width: 400px;
    padding: 12px 24px;
    border-radius: 6px;
    z-index: 9999;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.4);
    align-items: center;
    display: flex;
    will-change: opacity, transform;

    /* Uma única animação de 4s */
    animation: toastLife 4s ease forwards;

    @keyframes toastLife {
        0% {
            opacity: 0;
            transform: translateY(-10px);
        }
        7% {
            opacity: 1;
            transform: translateY(0);
        } /* fim do fade-in (~0.28s) */
        87% {
            opacity: 1;
            transform: translateY(0);
        } /* permanece visível */
        100% {
            opacity: 0;
            transform: translateY(-10px);
        } /* fade-out no final (~0.5s) */
    }
`;

export default function Toast({ message, onClose }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose?.();
        }, 4000);

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <ToastWrapper>
            <img
                src="../../img/icons_action/circle_check_approved.png"
                alt="Success"
                style={{ height: 20, marginRight: 10 }}
            ></img>
            {message}
        </ToastWrapper>
    );
}
